// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_Tj-","cls2":"AppsMegaMenu-cls2_gR5 AppsMegaMenu-cls1_Tj-"};